import CreateIcon from '@mui/icons-material/Create';
import { InternalStandardProps } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';
import { linkToEditForm } from '../../../crud-core/utils/Link';
import { Resource } from '../../../crud-graphql-containers/Utils/genericTypes';
import LinkButton from '../LinkButton';
import { useStyles } from './styles';

export type EditButtonProps = {
  buttonProps?: ButtonProps;
  item?: Object;
  buttonLabel?: string;
  resourceConfig?: Resource;
  queryParams?: string;
} & InternalStandardProps<React.HTMLAttributes<HTMLButtonElement>>;

const EditButton: React.FC<EditButtonProps> = ({
  buttonProps,
  className,
  item,
  buttonLabel = 'Edit',
  resourceConfig,
  style,
  queryParams = '',
}: EditButtonProps) => {
  const classes = useStyles();
  const props = {
    component: Link as any,
    icon: <CreateIcon className={classes.createIcon} />,
    to: resourceConfig && item ? linkToEditForm(resourceConfig, item, queryParams) : '',
    buttonLabel,
    buttonProps,
  };
  return <LinkButton {...props} className={className} style={style} />;
};

// eslint-disable-next-line import/no-default-export
export default EditButton;
